import { createContext } from 'react'
import type { PlanLimits } from '../../shared/plan-types'

export interface SessionResponse {
  authenticated: boolean
  configured: boolean
  email: string | null
  orgId: string | null
  plan: string | null
  orgName: string | null
  planLimits: PlanLimits | null
  monitorCount: number
  isSuperAdmin: boolean
  onboardingCompleted: boolean
}

export interface AuthContextValue {
  authenticated: boolean
  configured: boolean
  loading: boolean
  email: string | null
  orgId: string | null
  orgName: string | null
  plan: string | null
  planLimits: PlanLimits | null
  monitorCount: number
  isSuperAdmin: boolean
  onboardingCompleted: boolean
  needsOnboarding: boolean
  login: (email: string, password: string) => Promise<void>
  /** Resolves true when Supabase returned a session (user can enter the app). */
  signup: (email: string, password: string) => Promise<boolean>
  logout: () => Promise<void>
  refreshSession: () => Promise<SessionResponse>
}

export const AuthContext = createContext<AuthContextValue | null>(null)
